import { groupArrayBy } from '../../../../backend/utils/objectUtils';
import { AuthError } from '@juvare/platform-app/App';
export function getVolunteerApprovalRequests(req, shift, approvedParticipants) {
    const approvalRequestsByPositionId = groupArrayBy(req.shiftParticipations, (approveReq) => { var _a; return (_a = approveReq.positionId) !== null && _a !== void 0 ? _a : ''; });
    return Array.from(approvalRequestsByPositionId.keys()).reduce((result, positionId) => {
        var _a, _b, _c;
        const shiftPosition = (_b = (_a = shift.data) === null || _a === void 0 ? void 0 : _a.shiftPositions) === null || _b === void 0 ? void 0 : _b.find((p) => p.id === positionId);
        if (!shiftPosition) {
            throw new AuthError('Shift Position does not exist');
        }
        const currentApprovalRequests = (_c = approvalRequestsByPositionId.get(positionId)) !== null && _c !== void 0 ? _c : [];
        const alreadyApprovedCount = approvedParticipants.rows.filter((p) => p.columns.positionId === shiftPosition.id).length;
        if (shiftPosition.quantity - alreadyApprovedCount < currentApprovalRequests.length) {
            throw new AuthError('Number of approved Volunteers exceeds the positions needed.');
        }
        result.push(currentApprovalRequests);
        return result;
    }, []);
}
